import { createContext } from "react";

export type ToastSeverity = "success" | "error" | "warning" | "info";

export type ToastContextType = {
  showToast: (message: string, severity?: ToastSeverity) => void;
};

export const ToastContext = createContext<ToastContextType>({
  showToast: () => {},
});
